var Occurence = /** @class */ (function () {
    function Occurence(id, creationDateTime, companyName, userName, fundName, fundCnpjCpf, fundCode, description, occurrenceStatus, dateOccurrenceTypes, occurrenceComments, fundNumber) {
        this.id = id;
        this.creationDateTime = creationDateTime;
        this.companyName = companyName;
        this.description = description;
        this.userName = userName;
        this.fundName = fundName;
        this.fundCnpjCpf = fundCnpjCpf;
        this.fundCode = fundCode;
        this.occurrenceStatus = occurrenceStatus;
        this.dateOccurrenceTypes = dateOccurrenceTypes;
        this.occurrenceComments = occurrenceComments;
        this.fundNumber = fundNumber;
    }
    return Occurence;
}());
export { Occurence };
